import { render, staticRenderFns } from "./SuperTableBooks.vue?vue&type=template&id=bf6158ac"
import script from "./SuperTableBooks.vue?vue&type=script&lang=js"
export * from "./SuperTableBooks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports